import type React from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';

import { DepartmentsBody } from './body/DepartmentsBody';
import st from './DepartmentsPage.module.sass';
import { useDepartmentsPageTranslation } from './i18n';

function DepartmentsPage(): React.JSX.Element {
  const { t } = useDepartmentsPageTranslation();

  return (
    <Page className={st.Root}>
      <PageContent>
        <PageHeader title={t('title')} />
        <DepartmentsBody />
      </PageContent>
    </Page>
  );
}

export { DepartmentsPage };
